import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle } from "lucide-react";
import logoImg from "@/assets/images/logo.png";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/auth/esqueci-senha", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Erro ao solicitar redefinição");
      }
      setEnviado(true);
    } catch (err: any) {
      setError(err.message || "Erro ao solicitar redefinição");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={logoImg} alt="LaudoLegal" className="h-12" />
        </div>
        <Card className="p-8 border-none shadow-2xl">
          {enviado ? (
            <div className="text-center space-y-4" data-testid="text-email-enviado">
              <CheckCircle className="w-12 h-12 text-green-600 mx-auto" />
              <h1 className="text-xl font-bold text-slate-900">Verifique seu email</h1>
              <p className="text-muted-foreground text-sm">
                Se o email estiver cadastrado, você receberá um link de redefinição em instantes.
              </p>
              <a href="/login" className="text-primary hover:underline text-sm font-medium">
                Voltar para o login
              </a>
            </div>
          ) : (
            <>
              <div className="text-center mb-6">
                <h1 className="text-2xl font-bold text-slate-900">Esqueceu sua senha?</h1>
                <p className="text-muted-foreground mt-2 text-sm">
                  Informe seu email e enviaremos um link para redefinir sua senha.
                </p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4" data-testid="form-esqueci-senha">
                <div className="space-y-2">
                  <Label htmlFor="email">E-mail</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="nome@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="input-email"
                  />
                </div>
                {error && (
                  <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
                    {error}
                  </div>
                )}
                <Button type="submit" className="w-full h-11" disabled={loading} data-testid="button-enviar">
                  {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
                  Enviar link de redefinição
                </Button>
              </form>
              <div className="text-center mt-6">
                <a href="/login" className="text-sm text-primary hover:underline font-medium">
                  Voltar para o login
                </a>
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
